export const setChartOptionsByType = (chartOptions: object, defaultOptions: object) => {
  Object.entries(chartOptions)
    .map(([key, options]) => {
      if(typeof defaultOptions[key] !== 'object') {
        defaultOptions[key] = options;
      } else {
        setChartOptionsByType(options, defaultOptions[key]);
      }
    })
};